export const COAG = "COAG";
export const CUT = "CUT";
export const ENDOCUT_Q = "endoCUT Q";
export const ENDOCUT_I = "endoCUT I";
export const APC = "APC";
